module.exports = __webpack_public_path__ + "img/list_hk_lv1_global.9d957d85.png";